import { createIcon } from "@chakra-ui/icons";

const Recording02 = createIcon({
  displayName: "Recording02",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M3 10L3 14M7.5 11V13M12 6V18M16.5 3V21M21 10V14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default Recording02;
